// When adding an icon, please add it to the list below.
//
// **BEFORE ADDING: Preprocess the SVG**
// SVG icons are expressed as a series of strokes or fills.
// SVGs from figma either have a Fill or Stroke, and we can't configure them.
// So, to cover our bases, we like to use tailwind's tw-stroke-... and tw-fill-...
// in case the SVG icon uses either stroke or fill.
//
// The stroke and fill colors are also statically set in the SVG file.
//
// In order for coloring with classes to work, we must process the SVG icons.
// 1. Search for fill= in an SVG file
// - Replace fill="#..." with fill="current" unless fill="none". If fill="none", leave it be.
// - Add stroke="none"
// 2. Search for stroke= in an SVG file
// - Replace stroke="#..." with stroke="current" unless stroke="none". If stroke="none", leave it be.
// - Add fill="none"
//
// **Adding a brand icon?**
// See `./brandIcons.tsx`.

import { ReactComponent as AddCardIcon } from "../../icons/add-card.svg";
import { ReactComponent as AddCircleIcon } from "../../icons/add-circle.svg";
import { ReactComponent as AddIcon } from "../../icons/add.svg";
import { ReactComponent as AddUserIcon } from "../../icons/add-user.svg";
import { ReactComponent as AirplaneIcon } from "../../icons/airplane.svg";
import { ReactComponent as AlertInCircleIcon } from "../../icons/alert-in-circle.svg";
import { ReactComponent as AppleAppStoreDark } from "../../icons/apple-app-store-dark.svg";
import { ReactComponent as AppleAppStoreLight } from "../../icons/apple-app-store-light.svg";
import { ReactComponent as ArrowChevronLeft } from "../../icons/arrow-chevron-left.svg";
import { ReactComponent as ArrowChevronRight } from "../../icons/arrow-chevron-right.svg";
import { ReactComponent as ArrowDownIcon } from "../../icons/arrow-down.svg";
import { ReactComponent as ArrowLeftIcon } from "../../icons/arrow-left.svg";
import { ReactComponent as ArrowRightIcon } from "../../icons/arrow-right.svg";
import { ReactComponent as ArrowUpIcon } from "../../icons/arrow-up.svg";
import { ReactComponent as AvailabilityCalendarIcon } from "../../icons/availability-calendar.svg";
import { ReactComponent as BoldIcon } from "../../icons/bold.svg";
import { ReactComponent as BurgerMenuIcon } from "../../icons/burger-menu.svg";
import { ReactComponent as CalendarDottedIcon } from "../../icons/calendar-dotted.svg";
import { ReactComponent as CalendarFilledIcon } from "../../icons/calendar-filled.svg";
import { ReactComponent as CalendarIcon } from "../../icons/calendar.svg";
import { ReactComponent as CalendarRemoveIcon } from "../../icons/calendar-remove.svg";
import { ReactComponent as CameraIcon } from "../../icons/camera.svg";
import { ReactComponent as CancelIcon } from "../../icons/cancel.svg";
import { ReactComponent as CardEmptyIcon } from "../../icons/card-empty.svg";
import { ReactComponent as CardFilledIcon } from "../../icons/card-filled.svg";
import { ReactComponent as CartIcon } from "../../icons/cart.svg";
import { ReactComponent as ChairIcon } from "../../icons/chair.svg";
import { ReactComponent as ChatsFilledIcon } from "../../icons/chats-filled.svg";
import { ReactComponent as ChatsIcon } from "../../icons/chats.svg";
import { ReactComponent as CheckIcon } from "../../icons/check.svg";
import { ReactComponent as CheckInCircleIcon } from "../../icons/check-in-circle.svg";
import { ReactComponent as ChevronDownIcon } from "../../icons/chevron-down.svg";
import { ReactComponent as ChevronLeftIcon } from "../../icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "../../icons/chevron-right.svg";
import { ReactComponent as ChevronUpIcon } from "../../icons/chevron-up.svg";
import { ReactComponent as ClientIcon } from "../../icons/client.svg";
import { ReactComponent as ClientInCircleIcon } from "../../icons/client-in-circle.svg";
import { ReactComponent as ClientInCircleWithStarIcon } from "../../icons/client-in-circle-with-star.svg";
import { ReactComponent as ClientsFilledIcon } from "../../icons/clients-filled.svg";
import { ReactComponent as ClientsIcon } from "../../icons/clients.svg";
import { ReactComponent as ClipboardIcon } from "../../icons/clipboard.svg";
import { ReactComponent as ClockIcon } from "../../icons/clock.svg";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import { ReactComponent as CloseInCircleIcon } from "../../icons/close-in-circle.svg";
import { ReactComponent as CloudIcon } from "../../icons/cloud.svg";
import { ReactComponent as CommunityIcon } from "../../icons/community.svg";
import { ReactComponent as CopyIcon } from "../../icons/copy.svg";
import { ReactComponent as CrownIcon } from "../../icons/crown.svg";
import { ReactComponent as CycleIcon } from "../../icons/cycle.svg";
import { ReactComponent as DatabaseIcon } from "../../icons/database.svg";
import { ReactComponent as DocumentIcon } from "../../icons/document.svg";
import { ReactComponent as DoneIcon } from "../../icons/done.svg";
import { ReactComponent as DownloadIcon } from "../../icons/download.svg";
import { ReactComponent as ExitIcon } from "../../icons/exit.svg";
import { ReactComponent as EyeOffIcon } from "../../icons/eye-off.svg";
import { ReactComponent as EyeOnIcon } from "../../icons/eye-on.svg";
import { ReactComponent as FileIcon } from "../../icons/file.svg";
import { ReactComponent as FileMinimalIcon } from "../../icons/file-minimal.svg";
import { ReactComponent as FlameIcon } from "../../icons/flame.svg";
import { ReactComponent as FlaskFilledIcon } from "../../icons/flask-filled.svg";
import { ReactComponent as FlaskIcon } from "../../icons/flask.svg";
import { ReactComponent as FountainPenIcon } from "../../icons/fountain-pen.svg";
import { ReactComponent as GearIcon } from "../../icons/gear.svg";
import { ReactComponent as GiftIcon } from "../../icons/gift.svg";
import { ReactComponent as GooglePlayStoreDark } from "../../icons/google-play-store-dark.svg";
import { ReactComponent as GooglePlayStoreLight } from "../../icons/google-play-store-light.svg";
import { ReactComponent as HeartIcon } from "../../icons/heart.svg";
import { ReactComponent as HomeFilledIcon } from "../../icons/home-filled.svg";
import { ReactComponent as HomeIcon } from "../../icons/home.svg";
import { ReactComponent as ImagePlaceholderIcon } from "../../icons/image-placeholder.svg";
import { ReactComponent as ImageUploadIcon } from "../../icons/image-upload.svg";
import { ReactComponent as InfoIcon } from "../../icons/info.svg";
import { ReactComponent as ItalicIcon } from "../../icons/italic.svg";
import { ReactComponent as KeyIcon } from "../../icons/key.svg";
import { ReactComponent as LinkOutIcon } from "../../icons/link-out.svg";
import { ReactComponent as LoaderIcon } from "../../icons/loader.svg";
import { ReactComponent as LockIcon } from "../../icons/lock.svg";
import { ReactComponent as LockWithKeyholeIcon } from "../../icons/lock-keyhole.svg";
import { ReactComponent as LockWithKeyholeOpenIcon } from "../../icons/lock-keyhole-open.svg";
import { ReactComponent as LockUnlock2 } from "../../icons/lock-unlock-2.svg";
import { ReactComponent as MapPinIcon } from "../../icons/map-pin.svg";
import { ReactComponent as MarketplaceIcon } from "../../icons/marketplace.svg";
import { ReactComponent as MarketplaceFilledIcon } from "../../icons/marketplace-filled.svg";
import { ReactComponent as NotebookIcon } from "../../icons/notebook.svg";
import { ReactComponent as NotebookTextFilledIcon } from "../../icons/notebook-text-filled.svg";
import { ReactComponent as NotebookTextIcon } from "../../icons/notebook-text.svg";
import { ReactComponent as OrderedListIcon } from "../../icons/ordered-list.svg";
import { ReactComponent as PaperclipIcon } from "../../icons/paperclip.svg";
import { ReactComponent as PayoutsFilledIcon } from "../../icons/payouts-filled.svg";
import { ReactComponent as PayoutsIcon } from "../../icons/payouts.svg";
import { ReactComponent as PencilIcon } from "../../icons/pencil.svg";
import { ReactComponent as PencilWithLineIcon } from "../../icons/pencil-with-line.svg";
import { ReactComponent as PseudoCheckboxCheckIcon } from "../../icons/pseudo-checkbox-check.svg";
import { ReactComponent as QuestionIcon } from "../../icons/faqs.svg";
import { ReactComponent as QuotesIcon } from "../../icons/quotes.svg";
import { ReactComponent as ReceiptIcon } from "../../icons/receipt.svg";
import { ReactComponent as RepeatIcon } from "../../icons/repeat.svg";
import { ReactComponent as SearchIcon } from "../../icons/search.svg";
import { ReactComponent as SendIcon } from "../../icons/send.svg";
import { ReactComponent as Smartphone } from "../../icons/smartphone.svg";
import { ReactComponent as SparkleIcon } from "../../icons/sparkle.svg";
import { ReactComponent as SparkleFilledIcon } from "../../icons/sparkle-filled.svg";
import { ReactComponent as SparklePencilIcon } from "../../icons/sparkle-pencil.svg";
import { ReactComponent as StarIcon } from "../../icons/star.svg";
import { ReactComponent as SunriseIcon } from "../../icons/sunrise.svg";
import { ReactComponent as ThumbsUpIcon } from "../../icons/thumbs-up.svg";
import { ReactComponent as TimerIcon } from "../../icons/timer.svg";
import { ReactComponent as TrashCanIcon } from "../../icons/trash-can.svg";
import { ReactComponent as TrashCanWithLinesIcon } from "../../icons/trash-can-with-lines.svg";
import { ReactComponent as TrendDownIcon } from "../../icons/trend-down.svg";
import { ReactComponent as TrendUpIcon } from "../../icons/trend-up.svg";
import { ReactComponent as TripleDotsIcon } from "../../icons/triple-dots.svg";
import { ReactComponent as TurningBackIcon } from "../../icons/turning-back.svg";
import { ReactComponent as UnderlineIcon } from "../../icons/underline.svg";
import { ReactComponent as UnorderedListIcon } from "../../icons/unordered-list.svg";
import { ReactComponent as VideoIcon } from "../../icons/video.svg";
import { ReactComponent as ChecklistIcon } from "../../icons/checklist.svg";
import { ReactComponent as AppleAppStoreReviewDark } from "../../icons/apple-app-store-review-dark.svg";
import { ReactComponent as GooglePlayStoreReviewDark } from "../../icons/google-play-store-review-dark.svg";
import { ReactComponent as MobilePhoneIcon } from "../../icons/mobile-phone.svg";

import { SVGProps } from "react";

const SpinningLoaderIcon = ({
  className,
  ...restOfProps
}: SVGProps<SVGSVGElement>) => (
  <LoaderIcon className={`tw-animate-spin ${className}`} {...restOfProps} />
);

const ThumbsDownIcon = ({
  className,
  ...restOfProps
}: SVGProps<SVGSVGElement>) => (
  <ThumbsUpIcon className={`tw-rotate-180 ${className}`} {...restOfProps} />
);

export {
  AddCardIcon,
  AddCircleIcon,
  AddIcon,
  AddUserIcon,
  AirplaneIcon,
  AlertInCircleIcon,
  AppleAppStoreDark,
  AppleAppStoreLight,
  ArrowChevronLeft,
  ArrowChevronRight,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AvailabilityCalendarIcon,
  BoldIcon,
  BurgerMenuIcon,
  CalendarDottedIcon,
  CalendarFilledIcon,
  CalendarIcon,
  CalendarRemoveIcon,
  CameraIcon,
  CancelIcon,
  CardEmptyIcon,
  CardFilledIcon,
  CartIcon,
  ChairIcon,
  ChatsFilledIcon,
  ChatsIcon,
  CheckIcon,
  CheckInCircleIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ClientIcon,
  ClientInCircleIcon,
  ClientInCircleWithStarIcon,
  ClientsFilledIcon,
  ClientsIcon,
  ClipboardIcon,
  ClockIcon,
  CloseIcon,
  CloseInCircleIcon,
  CloudIcon,
  CommunityIcon,
  CopyIcon,
  CrownIcon,
  CycleIcon,
  DatabaseIcon,
  DocumentIcon,
  DoneIcon,
  DownloadIcon,
  ExitIcon,
  EyeOffIcon,
  EyeOnIcon,
  FileIcon,
  FileMinimalIcon,
  FlameIcon,
  FlaskFilledIcon,
  FlaskIcon,
  FountainPenIcon,
  GearIcon,
  GiftIcon,
  GooglePlayStoreDark,
  GooglePlayStoreLight,
  HeartIcon,
  HomeFilledIcon,
  HomeIcon,
  ImagePlaceholderIcon,
  ImageUploadIcon,
  InfoIcon,
  ItalicIcon,
  KeyIcon,
  LinkOutIcon,
  LoaderIcon,
  LockIcon,
  LockWithKeyholeIcon,
  LockWithKeyholeOpenIcon,
  LockUnlock2,
  MapPinIcon,
  MarketplaceIcon,
  MarketplaceFilledIcon,
  NotebookIcon,
  NotebookTextFilledIcon,
  NotebookTextIcon,
  OrderedListIcon,
  PaperclipIcon,
  PayoutsFilledIcon,
  PayoutsIcon,
  PencilIcon,
  PencilWithLineIcon,
  PseudoCheckboxCheckIcon,
  QuestionIcon,
  QuotesIcon,
  ReceiptIcon,
  RepeatIcon,
  SearchIcon,
  SendIcon,
  Smartphone,
  SparkleIcon,
  SparkleFilledIcon,
  SparklePencilIcon,
  SpinningLoaderIcon,
  StarIcon,
  SunriseIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TimerIcon,
  TrashCanIcon,
  TrashCanWithLinesIcon,
  TrendDownIcon,
  TrendUpIcon,
  TripleDotsIcon,
  TurningBackIcon,
  UnderlineIcon,
  UnorderedListIcon,
  VideoIcon,
  ChecklistIcon,
  AppleAppStoreReviewDark,
  GooglePlayStoreReviewDark,
  MobilePhoneIcon,
};
